exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".autocomplete-input[data-v-eae877be] {\n  width: 100% !important;\n  height: 40px !important;\n  padding: 8px 6px !important;\n  font-size: 16px !important;\n  border-radius: 0 !important;\n}\n.autocomplete-result-list[data-v-eae877be] {\n  border-radius: 0 !important;\n}", ""]);

// exports
